import { useState } from 'react';

import { ArrowDropDownCircleOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import {
  Content,
  Heading,
  DetailsWrapper,
  HeadingWrapper,
  ButtonWrapper,
  TagWrapper,
  StyledChip,
} from './styledComponents';
export interface DetailsProps {
  headingText: string;
  expanded: boolean;
  saved: boolean;
  error: boolean;
  actionButton?: JSX.Element;
  onClick: React.MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
}

export const Details: React.FC<DetailsProps> = ({
  headingText,
  children,
  expanded,
  error,
  saved,
  actionButton,
  ...rest
}) => {
  const [showButton, setShowButton] = useState(false);
  return (
    <DetailsWrapper>
      <HeadingWrapper
        onMouseEnter={() => setShowButton(true)}
        onMouseLeave={() => setShowButton(false)}
      >
        <Heading saved={saved} open={expanded} {...rest}>
          <div>{headingText}</div>
          <TagWrapper>
            {error && <StyledChip color='error' label='ERROR' />}
            {saved ? (
              <StyledChip color='success' label='COMPLETE' />
            ) : (
              <StyledChip color='secondary' label='UNSAVED' />
            )}
          </TagWrapper>
          <IconButton>
            {expanded ? (
              <ArrowDropDownCircleOutlined
                fontSize='large'
                sx={{
                  transform: 'rotate(180deg)',
                }}
              />
            ) : (
              <ArrowDropDownCircleOutlined fontSize='large' />
            )}
          </IconButton>
        </Heading>
        {showButton && <ButtonWrapper>{actionButton}</ButtonWrapper>}
      </HeadingWrapper>
      <Content open={expanded}>{children}</Content>
    </DetailsWrapper>
  );
};
